// Degradê diagonal esmaecido, sem ícone e sem forma arredondada — só textura de fundo.
export default function KpiCard({ icon, value, label }) {
  return (
    <div className="kpi-card">
      <span className="kpi-card__glow" aria-hidden="true" />
      <div className="kpi-card__icon">
        <span className="ms">{icon}</span>
      </div>
      <div className="kpi-card__value">{value}</div>
      <div className="kpi-card__label">{label}</div>
    </div>
  );
}
